import * as React from 'react';
import { Input as SemanticInput, Popup, TextArea } from "semantic-ui-react";
import { IVirtualizedTableCellComponentProps } from "../../VirtualizedTableInterfaces";

interface InputProps extends IVirtualizedTableCellComponentProps {}

interface InputState {
    value: string | number | undefined | null;
}

export default class Input extends React.Component<InputProps, InputState> {
    constructor(props: InputProps) {
        super(props);

        this.state = {
            value: this.props.value !== undefined && this.props.value !== null ? this.props.value : "", // Ensure initial value is controlled
        };
    }

    componentDidMount() {
        this.setState({
            value: this.props.value !== undefined && this.props.value !== null ? this.props.value : "", // Ensure value is controlled
        });
    }

    componentDidUpdate(prevProps: InputProps, prevState: InputState) {
        if (this.props.value !== prevProps.value && this.state.value !== this.props.value) {
            this.setState({
                value: this.props.value !== undefined && this.props.value !== null ? this.props.value : "", // Ensure value is controlled
            });
        }
    }

    private saveChange = () => {
        if (this.props.value !== this.state.value) {
            this.props.onChange(this.state.value);
        }
    }

    private renderInputWithPopUp() {
        return (
            <Popup
                openOnTriggerClick={true}
                closeOnDocumentClick={true}
                onClose={this.saveChange}
                trigger={
                    <SemanticInput
                        value={this.state.value}
                        fluid={true}
                        onChange={(e) => this.setState({ value: e.currentTarget.value })}
                        disabled={this.props.readOnly}
                    />
                }
                content={
                    <TextArea
                        value={this.state.value !== undefined && this.state.value !== null ? this.state.value : ""} // Ensure value is controlled
                        onChange={(e) => this.setState({ value: e.currentTarget.value })}
                        disabled={this.props.readOnly}
                    />
                }
            />
        );
    }

    private renderInputOnly() {
        return (
            <SemanticInput
                value={this.state.value !== undefined && this.state.value !== null ? this.state.value : ""} // Ensure value is controlled
                fluid={true}
                onChange={(e) => this.setState({ value: e.currentTarget.value })}
                disabled={this.props.readOnly}
                onBlur={this.saveChange}
            />
        );
    }

    public render() {
        if (this.props.inputWithPopup) {
            return this.renderInputWithPopUp();
        }
        return this.renderInputOnly();
    }
}



// WEBPACK FOOTER //
// ./src/components/Table/components/basic/Input.tsx